import { countProfileByMW, countProfileByMWh, countProfileByPercent, countProfileMaxAllowed } from './profile/profile';
import { countBandByMW, countBandByMWh, countBandByPercent, countBandMaxAllowed } from './band/band';
import {
  BUYING_VOLUME_PRODUCT_TYPE,
  CONTRACTED_VOLUME_PRODUCT_TYPE,
  REMAINING_VOLUME_PRODUCT_TYPE,
  percentageBigToNumber,
  volumeBigToNumber,
} from '../volumes';
import Big from 'big-js';
import { getHoursInMonthCzechTimeZone } from '../date';

export const PURCHASE_METHOD_PROFILE = 'PROFILE';
export const PURCHASE_METHOD_RANGE = 'RANGE';
export const PURCHASE_METHOD_PROFILE_SPOT = 'PROFILE+SPOT';
/**
 * @typedef {Object} PurchaseInfo
 * @property {BuyTotalsInfo} buyTotalsInfo
 * @property {ProductVolumeDef} buyingProduct
 */

/**
 * @typedef {Object} CountVolumesFunctions
 * @property {function(Big, ProductVolumeDef, number): {BuyInfo}} countByPercent
 * @property {function(Big, ProductVolumeDef, number): {BuyInfo}} countByMWh
 * @property {function(Big, ProductVolumeDef, number): {BuyInfo}} countByMW
 * @property {function(Volumes): {BuyInfo}} countMaxAllowed
 */

/**
 * @typedef {Object} BuyTotalsInfo
 * @property {number} percentage
 * @property {number} volumeMW
 * @property {number} volumeMWh
 */

/**
 * @typedef {Object} PeriodInfo
 * @property {Big} totalContractedMWh
 * @property {Big} hoursInPeriod
 */


/**
 * @param {PURCHASE_METHOD_RANGE|PURCHASE_METHOD_PROFILE|PURCHASE_METHOD_PROFILE_SPOT} contractType Contract type
 * @returns {CountVolumesFunctions} Functions to count volumes for specific type
 */
export const getCountVolumeFunctions = (contractType) => {
  if (contractType === PURCHASE_METHOD_PROFILE || contractType === PURCHASE_METHOD_PROFILE_SPOT) {
    return {
      countByPercent: countProfileByPercent,
      countByMWh: countProfileByMWh,
      countByMW: countProfileByMW,
      countMaxAllowed: countProfileMaxAllowed,
    };
  }
  return {
    countByPercent: countBandByPercent,
    countByMWh: countBandByMWh,
    countByMW: countBandByMW,
    countMaxAllowed: countBandMaxAllowed,
  };
};


/**
 * @param {Big} percentAsking PercentAsking
 * @param {Big} mwhAsking MwhAsking
 * @param {Big} mwAsking MwAsking
 * @returns {BuyTotalsInfo} buy info
 */
export const formatBuyInfo = (percentAsking, mwhAsking, mwAsking) => {
  return {
    percentage: percentageBigToNumber(percentAsking),
    volumeMWh: volumeBigToNumber(mwhAsking),
    volumeMW: volumeBigToNumber(mwAsking),
  };
};

/**
 * @param {ProductVolumeDef} periodContractedVolume periodContractedVolume
 * @param {number} year year
 * @returns {PeriodInfo} PeriodInfo
 */
export const getPeriodInfo = (periodContractedVolume, year) => {
  const periodInfo = {
    totalContractedMWh: new Big(0),
    hoursInPeriod: 0,
  };
  periodContractedVolume.quantities.forEach((monthQuantity) => {
    periodInfo.totalContractedMWh = periodInfo.totalContractedMWh.add(new Big(monthQuantity.quantity));
    periodInfo.hoursInPeriod += getHoursInMonthCzechTimeZone(year, monthQuantity.month - 1);
  });
  return {
    totalContractedMWh: periodInfo.totalContractedMWh,
    hoursInPeriod: new Big(periodInfo.hoursInPeriod),
  };
};

const getMonthQuantity = (productQuantity, month) => {
  return productQuantity.quantities.find((monthQuantity) => monthQuantity.month === month);
};

export const countAlreadyBought = (quantities, month) => {
  let alreadyBought = new Big(0);
  quantities.forEach((productQuantity) => {
    if (productQuantity.productType !== CONTRACTED_VOLUME_PRODUCT_TYPE &&
      productQuantity.productType !== BUYING_VOLUME_PRODUCT_TYPE &&
      productQuantity.productType !== REMAINING_VOLUME_PRODUCT_TYPE) {
      const monthQuantity = getMonthQuantity(productQuantity, month);
      if (monthQuantity) {
        alreadyBought = alreadyBought.add(new Big(monthQuantity.quantity));
      }
    }
  });
  return alreadyBought;
};
